import {
  KEYCLOAK_CLIENT,
  KEYCLOAK_HOST,
  KEYCLOAK_REALM,
  KEYCLOAK_CHECK_LOGIN_IFRAME,
} from './constants/env.constant';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

const keycloakConfig = {
  url: KEYCLOAK_HOST,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT,
};

export const keycloak = new Keycloak(keycloakConfig);

export const keycloakInitOptions: KeycloakInitOptions = {
  checkLoginIframe: KEYCLOAK_CHECK_LOGIN_IFRAME.toLowerCase() === 'true',
  onLoad: 'login-required',
};
